import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap'
import ContactUs from '../components/ContactUs'
import { useSelector } from 'react-redux'

const ContactUsPage = () => {
	const isPageLoading = useSelector((state) => state.pages.isLoading)
	return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
		<ContactUs />
	)
}

export default ContactUsPage